export enum BonusCalculationTypesEnum {
    Static = 'Static',
    Dynamic = 'Dynamic',
}

export enum SpinTabsActiveTabKeyEnum {
    Default = 'Default',
    Manual = 'Manual',
}

export enum AwardBudgetSetupTypesEnum {
    NoLimit = 'NoLimit',
    CountLimit = 'CountLimit',
    AmountLimit = 'AmountLimit',
}

export enum BudgetPeriodTypeEnum {
    Lifetime = 0,
    Month = 1,
    Week = 2,
    Day = 3,
    Year = 4,
}

export enum LimitBehaviorEnum {
    Warn = 1,
    WarnAndStop = 2,
}

export enum BudgetLimitTypeEnum {
    Count = 1,
    Amount = 2,
}

export enum AwardTypesEnum {
    DepositBonus = 2,
    NoDepositBonus = 3,
    CorrectionBonus = 4,
    FreeSpin = 5,
    FreeBet = 6,
    SkillGames = 8,
    BoostBonus = 9,
    FreeChip = 10,
    LoyaltyPoint = 12,
    CashBonus = 13,
    NFTBonus = 14,
    FrenchFreeBet = 15,
    LoyaltyBenefit = 17,
    WonderWheelSpin = 18,
    NftVoucherBonus = 19,
    PiePoints = 20,
}

export enum DynamicBonusTypesEnum {
    Object = 1,
    KPI = 2,
    FromFile = 3,
}

export enum AwardStepFieldNamesEnum {
    awardId = 'awardId',
    awardDetails = 'awardDetails',
    editData = 'editData',
    bonusData = 'bonusData',
    awardConfiguration = 'awardConfiguration',
    internalMessage = 'internalMessage',
    selectedWallet = 'selectedWallet',
}

export enum AwardConfFieldNamesEnum {
    internalMessage = 'internalMessage',
    expirationType = 'expirationType',
    expirationDateValue = 'expirationDateValue',
    expirationPeriodValue = 'expirationPeriodValue',
    selectedWallet = 'selectedWallet',
    bonusKind = 'bonusKind',
    percentage = 'percentage',
    considerLimits = 'considerLimits',
    bonusDetailsAmounts = 'bonusDetailsAmounts',
    bonusCalculateAction = 'bonusCalculateAction',
    bonusCalculationActiveTabKey = 'bonusCalculationActiveTabKey',
    budget = 'budget',
    budgetSetupActiveTabKey = 'budgetSetupActiveTabKey',
    budgetPeriod = 'budgetPeriod',
    limitBehavior = 'limitBehavior',
    countLimitCount = 'countLimitCount',
    amountLimitAmount = 'amountLimitAmount',
    amountLimitCurrency = 'amountLimitCurrency',
    radioGroupValue = 'radioGroupValue',
    spinPriceConfiguration = 'spinPriceConfiguration',
    spinTabsActiveTabKey = 'spinTabsActiveTabKey',
}
